export { default } from './Grafica';
